var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"test",on:{"click":function($event){$event.preventDefault();return _vm.togglePlay.apply(null, arguments)}}},[_vm._t("default",null,{"time":_vm.time,"isPlaying":_vm.isPlaying})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }